module.exports = __webpack_public_path__ + "static/media/foodIcon.31e29a6e.png";